export const LocationIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0004 11.1922C11.4363 11.1922 12.6004 10.0281 12.6004 8.59219C12.6004 7.15625 11.4363 5.99219 10.0004 5.99219C8.56445 5.99219 7.40039 7.15625 7.40039 8.59219C7.40039 10.0281 8.56445 11.1922 10.0004 11.1922Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3.01675 7.0763C4.65842 -0.140363 15.3501 -0.132029 16.9834 7.08464C17.9417 11.318 15.3084 14.9013 13.0001 17.118C11.3251 18.7346 8.67508 18.7346 6.99175 17.118C4.69175 14.9013 2.05842 11.3096 3.01675 7.0763Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}
